import { routeMappings, WorkflowItemCode } from '../../constants';
import { BasicForm } from '../interfaces/BasicForm';

export enum TaskItemStatus {
  VIEW_ALL = 'VIEW_ALL',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETE',
  NOT_STARTED = 'NOT_STARTED',
}

export const FORMS = 'FORMS';
export const defaultFormList: BasicForm[] = [
  {
    id: '1',
    name: 'applicationFormHeading',
    duration: 0,
    indicator: 'appFormIndicator',
    link: routeMappings['APPLICATION_FORM'],
    completionIndicator: 'applicationFormSubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
  {
    id: '2',
    name: 'researchQuestionsHeading',
    duration: 0,
    indicator: 'researchQuestionsIndicator',
    link: routeMappings['RESEARCH_QUESTIONS'],
    completionIndicator: 'researchQuestionSubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
  {
    id: '3',
    name: 'eeoHeading',
    duration: 0,
    indicator: 'eeoIndicator',
    link: routeMappings['EEO'],
    completionIndicator: 'eeoSubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
  {
    id: '4',
    name: 'ofccpHeading',
    duration: 0,
    indicator: 'ofccpIndicator',
    link: routeMappings['OFCCP'],
    completionIndicator: 'ofccpSubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
  {
    id: '5',
    name: 'responsibilityHeading',
    duration: 0,
    indicator: 'yourResponsibilityIndicator',
    link: routeMappings['YOUR_RESPONSIBILITY'],
    completionIndicator: 'yourResponsibilitySubmitted',
    status: TaskItemStatus.NOT_STARTED,
    code: WorkflowItemCode.FORMS,
  },
];

export const statusFilterList = [
  {
    key: TaskItemStatus.VIEW_ALL,
    value: 'taskTileViewAllStatus',
  },
  {
    key: TaskItemStatus.NOT_STARTED,
    value: 'taskTilePendingStatus',
  },
  {
    key: TaskItemStatus.IN_PROGRESS,
    value: 'taskTileInProgressStatus',
  },
  {
    key: TaskItemStatus.COMPLETED,
    value: 'taskTileCompletedStatus',
  },
];

export const mapTaskStatusValue: { [key: string]: string } = {
  VIEW_ALL: 'taskTileViewAllStatus',
  NOT_STARTED: 'taskTilePendingStatus',
  IN_PROGRESS: 'taskTileInProgressStatus',
  COMPLETE: 'taskTileCompletedStatus',
};
